/* ============
 * Product Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';
import ware from './productWarehouse';

export default class ProductSearchTransformer extends Transformer {

  static fetch(product) {
    let fieldsData = [];
    try {
      if (product.fields_json !== '') {
        if ((product.fields_json !== undefined || product.fields_json !== 'undefined') && product.fields_json !== null) {
          fieldsData = JSON.parse(product.fields_json);
        }
      }
    } catch (e) {
      fieldsData = [];
    }
    return {
      id: product.id,
      name: product.name,
      number: product.number,
      description: product.description,
      productGroupId: product.product_group_id,
      productType: product.product_type,
      productTypeId: product.product_type_id,
      productPackagingId: product.product_packaging_id,
      productPackagingName: product.product_packaging_name,
      price: product.price,
      taxPercentage: product.tax_percentage,
      taxId: product.tax_id,
      icon: product.icon ? { url: product.icon } : undefined,
      duration: product.duration,
      breaktime: product.breaktime,
      appointable: product.appointable,
      productDepositId: product.product_deposit_id,
      product_deposit_checkbox: product.product_deposit_checkbox,
      qty: product.qty,
      currentStock: product.qty,
      externalId: product.external_id,
      warehouses: product.warehouses !== undefined ? ware.fetchCollection(product.warehouses) : [],
      fieldsJSON: fieldsData,
      excisable: product.excisable,
      purchasePrice: product.purchase_price,
      costPrice: product.cost_price,
      errorUpdate: product.error_update,
      warehouseId: product.warehouse_id,
      orderProductNote: product.order_product_note,
      salePriceHoreca: product.salePriceHoreca,
      ddpVmp: product.ddpVmp,
    };
  }

  static send(product) {
    return {
      id: product.id,
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/transformers/productSearch.js